module.exports = __webpack_public_path__ + "img/trash-button-no-circle.ae631d3e.svg";